<template>
    <div>
        404 notFound
    </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
